import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CONTENT_STEP, LIST_SI } from "../../constant";
import {
  selectCurrentSiVoteGraphData,
  selectGu,
  selectSi,
  setContentStep,
  setCurrentSiVoteGraphData,
  setCurrentTownData,
  setGu,
  setSi,
} from "../../store/appSlice";
import {
  Modal,
  ModalDimmed,
  SelectBtn,
  SelectLi,
  SelectUl,
} from "../style/styled";
import data from "../../data/data.json";

export function CompSelectDistrict() {
  const dispatch = useDispatch();
  const currentSi = useSelector(selectSi);
  const currentGu = useSelector(selectGu);
  const currentSiVoteData = useSelector(selectCurrentSiVoteGraphData);

  const [modalSi, setModalSi] = useState(false);
  const [modalGu, setModalGu] = useState(false);

  const onClickSi = (dataSi) => {
    const filteredData = data.filter(({ sido }) => sido === dataSi);
    const currentSiGraphs = filteredData.map((item) => {
      return {
        sido: item.sido,
        sgg: item.sgg,
        category: item.category,
        chulsuk_16: item.chulsuk_16,
        chulsuk_17: item.chulsuk_17,
        chulsuk_18: item.chulsuk_18,
        chulsuk_19: item.chulsuk_19,
        count_winner: item.count_winner,
        sync_per: item.sync_per,
        syncper_19: item.syncper_19,
        syncper_19_rank: item.syncper_19_rank,
        voteNumRank_19: item.voteNumRank_19,
        votePeopleNum_19: item.votePeopleNum_19,
        winner_16: item.winner_16,
        winner_17: item.winner_17,
        winner_18: item.winner_18,
        winner_19: item.winner_19,
        winner_value_16: item.winner_value_16,
        winner_value_17: item.winner_value_17,
        winner_value_18: item.winner_value_18,
        winner_value_19: item.winner_value_19,
        best_shift_18_19: item.best_shift_18_19,
        first: {
          dirNum: item.dirNum_16_17,
          percent: item.shift_pct_16_17,
        },
        second: {
          dirNum: item.dirNum_17_18,
          percent: item.shift_pct_17_18,
        },
        third: {
          dirNum: item.dirNum_18_19,
          percent: item.shift_pct_18_19,
        },
      };
    });
    dispatch(setCurrentSiVoteGraphData(currentSiGraphs));
    dispatch(setSi(dataSi));
    setModalSi(false);
  };

  const onClickGu = (dataGu) => {
    const currentTownData = currentSiVoteData.find(({ sgg }) => sgg === dataGu);
    dispatch(setCurrentTownData(currentTownData));
    dispatch(setGu(dataGu));
    dispatch(setContentStep(CONTENT_STEP.GET_RESULT));
    setModalGu(false);
  };
  return (
    <>
      <SelectBtn type="button" onClick={() => setModalSi(true)}>
        {currentSi ? currentSi : "시를 선택하세요"}
      </SelectBtn>
      {modalSi && (
        <>
          <ModalDimmed onClick={() => setModalSi(false)}>
            <Modal>
              <SelectUl>
                {LIST_SI.map((si) => (
                  <SelectLi
                    key={si}
                    data-si={si}
                    onClick={(e) => onClickSi(e.target.getAttribute("data-si"))}
                  >
                    {si}
                  </SelectLi>
                ))}
              </SelectUl>
            </Modal>
          </ModalDimmed>
        </>
      )}
      <SelectBtn type="button" onClick={() => setModalGu(true)}>
        {currentGu ? currentGu : "구를 선택하세요"}
      </SelectBtn>
      {modalGu && currentSi && (
        <>
          <ModalDimmed onClick={() => setModalGu(false)}>
            <Modal>
              <SelectUl>
                {currentSiVoteData.map(({ sgg }) => (
                  <SelectLi
                    key={sgg}
                    data-gu={sgg}
                    onClick={(e) => onClickGu(e.target.getAttribute("data-gu"))}
                  >
                    {sgg}
                  </SelectLi>
                ))}
              </SelectUl>
            </Modal>
          </ModalDimmed>
        </>
      )}
      {modalGu && !currentSi && (
        <>
          <ModalDimmed onClick={() => setModalGu(false)}>
            <Modal>
              <SelectUl>
                <SelectLi>
                  <span>시를 먼저 선택하세요</span>
                </SelectLi>
                <SelectLi>
                  <button type="button" onClick={() => setModalGu(false)}>
                    닫기
                  </button>
                </SelectLi>
              </SelectUl>
            </Modal>
          </ModalDimmed>
        </>
      )}
    </>
  );
}
